/* eslint-disable camelcase */
import Cookie from 'js-cookie';
import superagent from '@ott/superagent';
import DM from '@ott/utility-date';

// eslint-disable-next-line consistent-return
function formatDate(date) {
  if (date) {
    return DM.formatISO(date); // 2018-04-18
  }
}

export default function getHeatmapRequest({
  isRT,
  fromCity,
  toCity,
  departure_date_from,
  departure_date_to,
  departure_or_return_date,
  return_date_from,
  return_date_to,
  deals_limit,
  all_combinations,
  direct_flights,
  noPricing,
  referrer,
}) {
  const queryParams = {
    origin: fromCity,
    destinations: toCity,
    departure_date_from: formatDate(departure_date_from),
    departure_date_to: formatDate(departure_date_to),
    departure_or_return_date: formatDate(departure_or_return_date),
    return_date_from: formatDate(return_date_from),
    return_date_to: formatDate(return_date_to),

    direct_flights,
    roundtrip_flights: isRT,
    noPricing,
    group_by_date: 'true',
    deals_limit,
    all_combinations,
    source: referrer || Cookie.get('referrer'),
  };

  Object.keys(queryParams).forEach((param) => {
    if (typeof queryParams[param] === 'undefined') {
      delete queryParams[param];
    }
  });

  return superagent.get('/_avia/deals_v4/directApiTop').query(queryParams).timeout(158000);
}
